export type review = {
  id: number;
  nameKey: string;
  raitingKey: string;
  quoteKey: string;
};

export const reviews: review[] = [
  {
    id: 1,
    nameKey: "review_1_name",
    raitingKey: "review_1_rating",
    quoteKey: "review_1_quote",
  },
  {
    id: 3,
    nameKey: "review_3_name",
    raitingKey: "review_3_rating",
    quoteKey: "review_3_quote",
  },



  {
    id: 6,
    nameKey: "review_6_name",
    raitingKey: "review_6_rating",
    quoteKey: "review_6_quote",
  },
  {
    id: 2,
    nameKey: "review_2_name",
    raitingKey: "review_2_rating",
    quoteKey: "review_2_quote",
  },
  {
    id: 5,
    nameKey: "review_5_name",
    raitingKey: "review_5_rating",
    quoteKey: "review_5_quote",
  }, {
    id: 8,
    nameKey: "review_8_name",
    raitingKey: "review_8_rating",
    quoteKey: "review_8_quote",
  }, {
    id: 4,
    nameKey: "review_4_name",
    raitingKey: "review_4_rating",
    quoteKey: "review_4_quote",
  }, {
    id: 7,
    nameKey: "review_7_name",
    raitingKey: "review_7_rating",
    quoteKey: "review_7_quote",
  },

];
